import { Inject, Injectable } from '@angular/core';
import { ComposeUrlService } from '../../api/services/compose-url.service';
import { WINDOW } from '../../common-app/services/window';


@Injectable()
export class BridgeTokenConfigProviderService {

  constructor(
    private composeUrlService: ComposeUrlService,
    @Inject(WINDOW) private window: Window
  ) { }

  public getUrl(): string {
    return this.composeUrlService.composeToolsUrl('authenticationBcV2');
  }

  public getCode(): string | undefined {
    switch (this.window.location.hostname) {
      case 'localhost':
        return undefined;
      case 'local.cosmosomni.com':
        return 'PYtX1Fdyc2lOS_eI-z-wlVazyvx11TVNKXoom_ffGPJ3AzFuNGMINg==';
      case 'test.cosmosomni.com':
        return 'PYtX1Fdyc2lOS_eI-z-wlVazyvx11TVNKXoom_ffGPJ3AzFuNGMINg==';
      case 'brownie.cosmosomni.com':
      case 'witty-ocean-02f42d003-releasecandidate.westeurope.5.azurestaticapps.net':
        return 'y0kUORCqoraJKcVZkqN8dVF5aic2ynznA-oAbQqZT84EAzFu9hkC6g==';
      default:
        return undefined;
    }
  }
}
